import { useMemo, useState } from "react";
import { attachActiveFeature } from "../utils/features";
import { COwithoutFeatDataType } from "../types/connected-object";
import { OrderType } from "../types/pagination";

export default function useSortObject(
  data?: COwithoutFeatDataType[]
) {
  const [colToSort, setColToSort] = useState<null | {target: string; value: OrderType}>(null);
  const connectedObjects = useMemo(() => {
    if (!data) return null;
    if (!colToSort || colToSort.value === 'none') return attachActiveFeature(data);
    const {target, value} = colToSort;
    return sortObjects(data, target, value);
  }, [data, colToSort]);

  return {colToSort, setColToSort, connectedObjects}
}

function sortObjects (data: COwithoutFeatDataType[], target: string, orderBy: 'DESC' | 'ASC' ) {  
  const sortOrder = orderBy === 'DESC' ? -1 : 1;
  return [...attachActiveFeature(data)].sort((a, b) => {
    if (target === 'url') {
      return a.url.localeCompare(b.url) * sortOrder;
    }
    if (target === 'feat') {
      const featA = a.activeFeature?.type ?? '';
      const featB = b.activeFeature?.type ?? '';
      return featA.localeCompare(featB) * sortOrder;
    }
    if (target === 'activatedAt') {
      const dateA = a.activatedAt?.toLocaleString() ?? '';
      const dateB = b.activatedAt?.toLocaleString() ?? '';
      return dateA.localeCompare(dateB) * sortOrder;
    }
    return 0;
  })
}